"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginatedResult = void 0;
const typebox_1 = require("@sinclair/typebox");
const PaginatedResult = (object) => typebox_1.Type.Object({
    results: typebox_1.Type.Array(object),
    total: typebox_1.Type.Number(),
    offset: typebox_1.Type.Number(),
    thisBatch: typebox_1.Type.Number(),
});
exports.PaginatedResult = PaginatedResult;
//# sourceMappingURL=PaginatedResult.js.map